import LogRecord from './LogRecord';

export type WebsocketMessages = AllLogsMessage | SingleLogMessage;
export enum WebsocketMessageType {
  SingleLog = 'SINGLE_LOG',
  AllLogs = 'ALL_LOGS',
}

export type SingleLogMessage = {
  type: WebsocketMessageType.SingleLog;
  logRecord: LogRecord;
};

export type AllLogsMessage = {
  type: WebsocketMessageType.AllLogs;
  logRecords: LogRecord[];
};
